export { default as BaseHead } from './BaseHead'
export { default as DocumentNumber } from './DocumentNumber'
export { default as DocumentTypes } from './DocumentTypes'
export { default as SEO } from './SEO'
